import { render, staticRenderFns } from "./ReservationProduct.vue?vue&type=template&id=52c38a0a&scoped=true"
import script from "./ReservationProduct.vue?vue&type=script&lang=js"
export * from "./ReservationProduct.vue?vue&type=script&lang=js"
import style0 from "./ReservationProduct.vue?vue&type=style&index=0&id=52c38a0a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c38a0a",
  null
  
)

export default component.exports